.mfa-codes {
    margin-top: 12px;
}
